import { createNodeDef } from "../nodes.helpers";

export const mergeNodeDef = createNodeDef({
  type: "merge",
  displayName: "Merge",
  description: "Merges multiple arrays or objects",
  acceptsChildren: true,
  initialData: () => ({}),
  generate: async ({ children }) => {
    const results: unknown[] = await children.generateValues();

    const areAllObjects = results.every((result) => {
      // This includes null but that's ok because Object.assign can handle null values
      return typeof result === "object" && !Array.isArray(result);
    });

    if (areAllObjects) {
      return Object.assign({}, ...results);
    }

    return results.reduce<unknown[]>((acc, result) => {
      acc.push(...(Array.isArray(result) ? result : [result]));
      return acc;
    }, []);
  },
});
